import React from "react";
import { EditStatusUserModal } from "../../Modal/EditStatusUserModal";

export function UserEditStatusModal({
  isLoadingEditUserStatus,
  isEditStatusModal,
  data,
  formikEditStatusUser,
  onClickOfEditStatusCancelButton,
}) {
  return (
    <>
      <EditStatusUserModal
        isLoadingEditUserStatus={isLoadingEditUserStatus}
        isEditStatusModal={isEditStatusModal}
        data={data}
        formikEditStatusUser={formikEditStatusUser}
        onClickOfEditStatusCancelButton={onClickOfEditStatusCancelButton}
      />
    </>
  );
}
